import uniqueId from "lodash/uniqueId";

import type { Contact } from "app/pages/sales-intelligence/modules/ai-agent/types/meeting";

export const MAX_DISPLAYED_CONTACTS = 6;

export const parseContactString = (value: string): Pick<Contact, "name" | "title"> => {
    const index = value.search(/,/);
    return {
        name: index !== -1 ? value.slice(0, index).trim() : value.trim(),
        title: index !== -1 ? value.slice(index + 1).trim() : "",
    };
};

export const getSearchStringErrorVariant = (value: string | undefined): "email" | "URL" | undefined => {
    if (value?.includes("@")) {
        return "email";
    } else if (value?.includes("linkedin.com/in/")) {
        return "URL";
    }

    return;
};

export const sortContactsBySelected = (contacts: Contact[]): Contact[] => {
    return contacts.sort((a, b) => {
        if (a.isSelected && !b.isSelected) {
            return -1;
        }
        if (!a.isSelected && b.isSelected) {
            return 1;
        }
        return 0;
    });
};

export const switchContactSelection = (contacts: Contact[], idToChange: string | undefined): Contact[] =>
    contacts.map((c) => (c.id === idToChange ? { ...c, isSelected: !c.isSelected } : c));

export const createNewContact = ({ name, title, source }: Pick<Contact, "name" | "title" | "source">): Contact => ({
    name: name ?? "",
    title: title ?? "",
    isSelected: true,
    id: uniqueId(),
    source,
});

export const stringifyContact = (contacts: Contact): string =>
    contacts.title ? `${contacts.name}, ${contacts.title}` : (contacts.name ?? "");

export const mapContactsWithSelectionState = (contacts: Contact[], selectedContacts: Contact[]): Contact[] => {
    return contacts.map((contact) => {
        const existingContact = selectedContacts.find((c) => c.name === contact.name && c.title === contact.title);
        return {
            ...contact,
            isSelected: existingContact?.isSelected || false,
            id: existingContact?.id || uniqueId(),
            isSuggested: true,
        };
    });
};

export const mergeSelectedWithSuggestions = (selectedContacts: Contact[], suggestions: Contact[]): Contact[] => {
    const remainingSlots = MAX_DISPLAYED_CONTACTS - selectedContacts.length;

    if (remainingSlots <= 0) {
        return selectedContacts;
    }

    const filteredSuggestions = suggestions
        .filter((suggestion) => {
            return !selectedContacts.some(
                (selected) => selected.name === suggestion.name && selected.title === suggestion.title,
            );
        })
        .slice(0, remainingSlots)
        .map((suggestion) => ({
            ...suggestion,
            isSelected: false,
            id: uniqueId(),
            isSuggested: true,
        }));

    return [...selectedContacts, ...filteredSuggestions];
};
